import * as FiIcons from 'react-icons/fi';

export const categories = [
  { id: 'all', name: 'All Categories', icon: FiIcons.FiGrid },
  { id: 'audio', name: 'Audio & Music', icon: FiIcons.FiMusic },
  { id: 'writing', name: 'Writing & Content', icon: FiIcons.FiEdit },
  { id: 'design', name: 'Design & Graphics', icon: FiIcons.FiImage },
  { id: 'productivity', name: 'Productivity', icon: FiIcons.FiZap },
  { id: 'analytics', name: 'Analytics & Data', icon: FiIcons.FiTrendingUp },
  { id: 'marketing', name: 'Marketing', icon: FiIcons.FiTarget },
  { id: 'automation', name: 'Automation', icon: FiIcons.FiRefreshCw },
  { id: 'social', name: 'Social Media', icon: FiIcons.FiShare2 },
  { id: 'finance', name: 'Finance & Crypto', icon: FiIcons.FiDollarSign },
  { id: 'health', name: 'Health & Fitness', icon: FiIcons.FiHeart },
  { id: 'education', name: 'Education', icon: FiIcons.FiBookOpen }
];

export const miniSaasProjects = [
  {
    id: 36,
    name: 'Coverlab',
    description: 'Generate stunning UHD music covers in seconds using advanced neural synthesis. Designed for musicians, labels, and producers.',
    url: 'https://coverlab.dadda.cool/',
    category: 'audio',
    dateAdded: '2024-06-18',
    featured: true,
    tags: ['Album Art', 'AI', 'Music', 'Cover Generator', 'Neural Synthesis']
  },
  {
    id: 35,
    name: 'Vidroid',
    description: 'Ai Video Generator - using BYOK API Key from cheapest Api markets. Transform your ideas into cinematic reality with cutting-edge AI models including Sora 2, Veo 3.1 and other video models. Create stunning videos from text/image in seconds with your BYOK API credentials.',
    url: 'https://vidroid.app',
    category: 'design',
    dateAdded: '2024-06-17',
    featured: true,
    tags: ['Video Generator', 'AI', 'Sora 2', 'Veo 3.1', 'BYOK']
  },
  {
    id: 33,
    name: 'YouTube to MP3',
    description: 'Free Youtube to Mp3 Converter. Quickly convert YouTube videos to MP3.',
    url: 'https://yt2mp3.fiverring.com/',
    category: 'audio',
    dateAdded: '2024-06-15',
    featured: false,
    tags: ['YouTube', 'MP3', 'Converter', 'Audio']
  },
  {
    id: 32,
    name: 'Ai8848 - AI VIDEO GENERATION',
    description: 'Transform your ideas into cinematic reality with the power of Sora 2 AI. Create stunning videos from text in seconds using your own KIE.ai API credentials, no watermark and BYOK.',
    url: 'https://ai8848.app/',
    category: 'design',
    dateAdded: '2024-06-14',
    featured: true,
    tags: ['Video Generation', 'AI', 'Sora 2', 'Text to Video', 'BYOK']
  },
  {
    id: 30,
    name: 'Magic Ai',
    description: 'AI Message Generator - Turn a single idea into perfectly crafted posts for all your platforms',
    url: 'https://magicai.gpt5.au/',
    category: 'social',
    dateAdded: '2024-06-12',
    featured: false,
    tags: ['Social Media', 'AI', 'Generator', 'Content']
  },
  {
    id: 29,
    name: 'AI Storyboard Generator',
    description: 'Transform your scripts into detailed storyboards with AI-generated visual prompts and motion directions',
    url: 'https://aistoryboard.gpt5.au',
    category: 'design',
    dateAdded: '2024-06-11',
    featured: true,
    tags: ['Storyboard', 'AI', 'Video', 'Scripts', 'Visuals']
  },
  {
    id: 27,
    name: 'PDFly',
    description: 'Professional PDF Tools. Clean & Secure. Transform your documents instantly. Many PDF tools coming to PDFly. No servers, very secured.',
    url: 'https://pdf.gpt5.au/',
    category: 'productivity',
    dateAdded: '2024-06-11',
    featured: false,
    tags: ['PDF', 'Tools', 'Secure', 'Converter']
  },
  {
    id: 26,
    name: 'Brutal Tags',
    description: 'Start growing on YouTube & TikTok. Generate brutal tags in seconds. No fluff. Just reach.',
    url: 'https://tags.gpt5.au/',
    category: 'social',
    dateAdded: '2024-06-10',
    featured: false,
    tags: ['Tags', 'YouTube', 'TikTok', 'Growth', 'Social Media']
  },
  {
    id: 25,
    name: 'GPT5 Prompts',
    description: 'Discover the future of AI prompting with our curated collection of high-quality, completely free prompts',
    url: 'https://ultrachatgpt.com',
    category: 'writing',
    dateAdded: '2024-06-09',
    featured: true,
    tags: ['Prompts', 'AI', 'GPT-5', 'Free']
  },
  {
    id: 24,
    name: 'Digital Resume Creator',
    description: 'Stunning Digital CV Builder. Free Online Tool to customize & export HTML and take it live for free!!',
    url: 'https://resume.gpt5.au/',
    category: 'design',
    dateAdded: '2024-06-08',
    featured: false,
    tags: ['Resume', 'CV', 'Builder', 'No-Code']
  },
  {
    id: 23,
    name: 'SoraMuse',
    description: 'Your AI-powered co-creator for stunning Sora 2 videos. Engage in a dynamic chat with our expert AI director to discover hidden visual ideas and craft the perfect, detailed prompt for your next AI masterpiece.',
    url: 'https://sora.gpt5.au/',
    category: 'writing',
    dateAdded: '2024-06-07',
    featured: false,
    tags: ['Sora', 'Video', 'Prompts', 'AI Director']
  },
  {
    id: 22,
    name: 'Math Solver',
    description: 'Get step-by-step solutions and clear explanations for problems ranging from elementary arithmetic to advanced calculus, all within a charming claymorphism interface.',
    url: 'https://math.gpt5.au/',
    category: 'education',
    dateAdded: '2024-06-06',
    featured: false,
    tags: ['Math', 'Education', 'Calculus', 'Solver']
  },
  {
    id: 21,
    name: 'ViralSpark',
    description: 'Ignite your content! ViralSpark crafts complete social media packages for your videos in seconds. Upload your script or description and get optimized titles, engaging captions, relevant tags, and creative thumbnail prompts—all tailored for platforms like YouTube, TikTok, and Instagram.',
    url: 'https://goviral.gpt5.au/',
    category: 'social',
    dateAdded: '2024-06-05',
    featured: false,
    tags: ['Social Media', 'Viral', 'Content', 'Marketing']
  },
  {
    id: 20,
    name: 'ThumbGPT',
    description: 'Instantly download high-quality YouTube thumbnails in seconds. Simply paste a video URL, preview the thumbnail, and download it in max resolution.',
    url: 'https://thumb.gpt5.au/',
    category: 'social',
    dateAdded: '2024-06-04',
    featured: false,
    tags: ['YouTube', 'Thumbnail', 'Downloader', 'Social Media']
  },
  {
    id: 18,
    name: 'ExcelGenie',
    description: 'Your AI assistant for mastering Excel. Understand, write, and generate formulas, steps, and explanations with ease. Analyze your spreadsheets for instant insights and improvements.',
    url: 'https://excelgenie.gpt5.au/',
    category: 'productivity',
    dateAdded: '2024-06-02',
    featured: false,
    tags: ['Excel', 'Spreadsheets', 'AI', 'Productivity']
  },
  {
    id: 17,
    name: 'ThreadGPT',
    description: 'Generate viral social media threads instantly with ThreadGPT, the AI-powered content creation tool. Explore templates, join the community, and boost your engagement.',
    url: 'https://thread.gpt5.au/',
    category: 'social',
    dateAdded: '2024-06-01',
    featured: false,
    tags: ['Threads', 'Social Media', 'AI', 'Content']
  },
  {
    id: 16,
    name: 'Formz',
    description: 'Formz lets you build clean forms fast. You can create custom fields, share links, and collect data without clutter. You control the layout, the questions, and the responses.',
    url: 'https://formz.base44.app/',
    category: 'productivity',
    dateAdded: '2024-05-31',
    featured: false,
    tags: ['Forms', 'Data Collection', 'Productivity', 'Builder']
  },
  {
    id: 14,
    name: 'TikRead',
    description: 'Discover bite-sized text content in a seamless vertical feed, personalized to your interests.',
    url: 'https://tikread.app/',
    category: 'writing',
    dateAdded: '2024-05-29',
    featured: false,
    tags: ['Reading', 'Feed', 'Discovery', 'Content']
  },
  {
    id: 13,
    name: 'MedexplainGPT',
    description: 'AI-powered platform that transforms complex medical reports into crystal-clear insights.',
    url: 'https://medexplain.gpt5.au/',
    category: 'health',
    dateAdded: '2024-05-28',
    featured: false,
    tags: ['Medical', 'AI', 'Health', 'Reports']
  },
  {
    id: 11,
    name: 'JSON Prompt Builder',
    description: 'Create beautiful AI video prompts with ease.',
    url: 'https://veo3.gpt5.au/',
    category: 'writing',
    dateAdded: '2024-05-21',
    featured: true,
    tags: ['Prompts', 'AI Video', 'JSON', 'Generator']
  },
  {
    id: 10,
    name: 'ThankYouForComing',
    description: 'A Thanksgiving themed multi tool app with fun tools including cards, recipes, gratitude notes, quizzes, a seating planner, and more.',
    url: 'https://thankyouforcoming.netlify.app/',
    category: 'productivity',
    dateAdded: '2024-11-20',
    featured: false,
    tags: ['Thanksgiving', 'Planner', 'Cards', 'Multi-tool']
  },
  {
    id: 9,
    name: 'PostGenerator',
    description: 'Create AI powered Instagram posts in seconds. PostGenerator creates Instagram images, carousels, captions, and hashtags.',
    url: 'https://postsgenerator.netlify.app',
    category: 'social',
    dateAdded: '2024-02-28',
    featured: false,
    tags: ['Instagram', 'AI Generator', 'Social Media']
  },
  {
    id: 8,
    name: 'Bio Creator',
    description: 'Create a dark themed personal bio page with cards, custom avatar, preset icons, theme controls, and export as a single HTML file ready for Netlify.',
    url: 'https://bio.gpt5.au/',
    category: 'design',
    dateAdded: '2024-02-25',
    featured: false,
    tags: ['Bio Page', 'Portfolio', 'No-Code', 'HTML Export']
  },
  {
    id: 1,
    name: 'Spit Audio',
    description: 'AI-powered audio splitting tool for musicians and podcasters or Creators',
    url: 'https://splitaudios.netlify.app/',
    category: 'audio',
    dateAdded: '2024-01-15',
    featured: false,
    tags: ['Audio Processing', 'AI Splitting', 'Music Production']
  },
  {
    id: 2,
    name: 'TikSnap',
    description: 'TikTok Video Download Without Watermark. Fast. All devices.',
    url: 'https://tiksnap.xyz/',
    category: 'social',
    dateAdded: '2024-01-26',
    featured: false,
    tags: ['TikTok', 'Video Downloader', 'No Watermark']
  },
  {
    id: 3,
    name: 'TwitLoad',
    description: 'TwitLoad lets you download Twitter X videos without a watermark. Simple layout, quick processing, works on all devices, no storage.',
    url: 'https://twitload.netlify.app/',
    category: 'social',
    dateAdded: '2024-02-12',
    featured: false,
    tags: ['Twitter', 'X', 'Video Downloader', 'No Watermark']
  },
  {
    id: 5,
    name: 'QRAI',
    description: 'QRAI generates QR codes from any URL quickly. Simple interface, fast processing, works on all devices, no storage.',
    url: 'https://qrai-generator.netlify.app/',
    category: 'productivity',
    dateAdded: '2024-02-18',
    featured: false,
    tags: ['QR Code', 'Generator', 'Utility']
  },
  {
    id: 6,
    name: 'CalAll',
    description: 'CalAll offers a suite of calculators and converters on one page. Fast, simple, works on all devices, no storage. Open any tool in a new page for detailed use.',
    url: 'https://calall.netlify.app/',
    category: 'productivity',
    dateAdded: '2024-02-20',
    featured: false,
    tags: ['Calculators', 'Converters', 'Utility']
  },
  {
    id: 7,
    name: 'ColorLab',
    description: 'ColorLab helps you generate, visualize, and explore color palettes. Fast, simple, works on all devices, no storage. Test colors on real designs in real time.',
    url: 'https://colours-lab.netlify.app',
    category: 'design',
    dateAdded: '2024-02-22',
    featured: false,
    tags: ['Color Palette', 'Branding', 'Design Tool']
  }
];